export default function($) {

  function add_to_cart(quantity, product_id, variation_id=0) {
    if (quantity > 0) {

      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          "action" : "woocommerce_add_variations_to_cart", // from ImagileWooCommerce plugin
          "variations" : [{
            "product_id" : product_id,
            "variation_id" : variation_id,
            "quantity" : quantity,
          }],
        },
        type: "POST"
      })
      .done(function() {
        // We force refresh woocommerce mini-cart fragments using
        // WooCommerce native event 'wc_fragment_refresh'
        $('#add-to-cart-product-'+product_id).siblings('.js-added-to-cart').removeClass('hidden');
        $('#add-to-cart-variable-product-'+variation_id).siblings('.js-added-to-cart').removeClass('hidden');
        $( document.body ).trigger( 'wc_fragment_refresh' );
      })
    }
  }

  // ---------------------
  // Variation add to cart
  // ---------------------
  var add_variation_to_cart_buttons = $('.js-product-variation-add-to-cart');

  // we do nothing if the selector is not found
  if ( add_variation_to_cart_buttons.length > 0 ) {
    add_variation_to_cart_buttons.each(function () {
      $(this).click(function(event) {
        event.preventDefault()

        var quantity_input = $(this).closest('.js-product-variation').find('.js-variation-quantity')

        var quantity = quantity_input.val();
        var product_id = quantity_input.data('product-id')
        var variation_id = quantity_input.data('variation-id')

        add_to_cart( quantity, product_id, variation_id )
      })
    })
  }
  // ---------------------


  // ---------------------
  // Product add to cart
  // ---------------------
  var add_product_to_cart_buttons = $('.js-product-add-to-cart');

  // we do nothing if the selector is not found
  if ( add_product_to_cart_buttons.length > 0 ) {
    add_product_to_cart_buttons.each(function () {
      $(this).click(function(event) {
        event.preventDefault()

        var quantity_input = $(this).closest('.js-product').find('.js-product-quantity')

        var quantity = quantity_input.val();
        var product_id = quantity_input.data('product-id')

        add_to_cart( quantity, product_id )
      })
    })
  }
  // ---------------------

}
